import React, { lazy } from 'react';
import { Product } from '../types/types';
import { CONFIG } from '../data/config';
import { PlusIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
interface ProductCardProps {
  product: Product;
  onAdd: (product: Product) => void;
}
export function ProductCard({
  product,
  onAdd
}: ProductCardProps) {
  const {
    t,
    formatPriceInline,
    translateProductName,
    translateProductDescription
  } = useLanguage();
  const translatedName = translateProductName(product.id, product.name);
  const translatedDescription = translateProductDescription(product.id, product.description);
  return <div className="bg-surface rounded-2xl shadow-sm border border-gray-800 flex flex-col h-full overflow-hidden" data-id="element-1173">
      {product.image && <div className="h-28 w-full bg-surface-light relative" data-id="element-1174">
          <img src={product.image} alt={translatedName} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-1175" />
        </div>}
      <div className="p-4 flex flex-col flex-1" data-id="element-1176">
        <div className="flex-1" data-id="element-1177">
          <div className="flex justify-between items-start mb-2 gap-2" data-id="element-1178">
            <h3 className="font-heading font-semibold text-white text-base leading-tight tracking-wide" data-id="element-1179">
              {translatedName}
            </h3>
            <span className="font-semibold text-verde whitespace-nowrap text-xs flex flex-col items-end" data-id="element-1180">
              {formatPriceInline(product.price)}
            </span>
          </div>
          {translatedDescription && <p className="text-gray-400 text-xs leading-snug mb-3 line-clamp-3" data-id="element-1181">
              {translatedDescription}
            </p>}
        </div>

        <button onClick={() => onAdd(product)} className="mt-auto w-full bg-terracota/10 text-terracota font-medium py-2.5 rounded-xl flex items-center justify-center gap-1 active:bg-terracota active:text-white transition-colors min-h-[44px] text-sm border border-terracota/20" data-id="element-1182">
          {product.customizable ? <>
              {t('customize')} <PlusIcon className="w-4 h-4" data-id="element-1183" />
            </> : <>
              {t('add')} <PlusIcon className="w-4 h-4" data-id="element-1184" />
            </>}
        </button>
      </div>
    </div>;
}